import type { ReactNode } from "react";
import { cn } from "@synthesis/shared-utils";

type ProfileRowProps = {
  label: string;
  children: ReactNode;
  className?: string;
};

export const ProfileRow = ({ label, children, className }: ProfileRowProps) => (
  <div className={cn("border-neutrals-90 grid min-h-12 grid-cols-[9rem_minmax(0,1fr)] items-start gap-4 border-b py-1 last:border-b-0", className)}>
    <p className="paragraph-base text-type-light py-3">{label}</p>
    <div className="paragraph-base w-full min-w-0 self-center py-3">{children}</div>
  </div>
);
